// The theme's own GA4 events, for what Shopify's Google channel cannot see: a tap on the gray Check out
// (vv-checkout-terms.js), every pop-up's showing, close and clicks (vv-attention.js) and the SMS sign-up
// (vv-sms-sheet.js), sent only with the visitor's analytics consent.
// The channel's Google tag runs on the page itself (read on the live store 2026-10-19: window.gtag, and
// google_tag_manager holds G-6E19WW3Z02), so an event goes through it, in the visit's GA4 session with its traffic
// source, and no second tag repeats the channel's automatic events (scroll, user_engagement, form_start). When the
// channel's tag is not on the page, the first event loads Google's tag on a data layer of its own, vvGtagLayer, with no
// page view. The measurement id is the script tag's data-ga4-id, set in layout/theme.liquid.
(() => {
  const measurementId = document.currentScript?.dataset.ga4Id;
  if (!measurementId || window.vvGa4) return;
  let loaded = false;

  window.vvGa4 = {
    allowed: () => Boolean(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()),

    // Sends one event, and returns whether it went.
    event(name, params) {
      if (!this.allowed()) return false;
      if (!loaded && typeof window.gtag === 'function' && window.google_tag_manager?.[measurementId]) {
        window.gtag('event', name, { ...params, send_to: measurementId });
        return true;
      }
      const layer = (window.vvGtagLayer = window.vvGtagLayer || []);
      const gtag = function () { layer.push(arguments); };
      if (!loaded) {
        loaded = true;
        gtag('js', new Date());
        gtag('config', measurementId, { send_page_view: false });
        const tag = document.createElement('script');
        tag.async = true;
        tag.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}&l=vvGtagLayer`;
        document.head.appendChild(tag);
      }
      gtag('event', name, params);
      return true;
    },
  };
})();
